import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

const WistiaVideo = ({ videoWalkaround }) => {
  const [ref, inView] = useInView({
    rootMargin: '100px 0px',
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      const scripts = [
        `https://fast.wistia.com/embed/medias/${videoWalkaround}.jsonp`,
        'https://fast.wistia.com/assets/external/E-v1.js',
      ];

      scripts.forEach((src) => {
        const script = document.createElement('script');
        script.src = src;
        document.body.appendChild(script);
      });
    }
  }, [inView]);

  return (
    <div className="wistia_responsive_padding" ref={ref}>
      <div className="wistia_responsive_wrapper">
        <div
          className={`wistia_embed wistia_async_${videoWalkaround} videoFoam=true`}
        >
          &nbsp;
        </div>
      </div>
    </div>
  );
};

export default WistiaVideo;

WistiaVideo.propTypes = {
  videoWalkaround: PropTypes.string,
};
